<div class="backSection">
  <button class="btn backSection__backButton"><a [routerLink]="'/'+ROUTING.STUDENT.CAREERS_LIST"><img
        src={{IMAGES.REPORT_BACK}}> Back </a></button>
</div>
